import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/peche";
export default function SecteurPeche() { return <SectorLayout data={data} />; }
